import { render, staticRenderFns } from "./poa_programaticas.vue?vue&type=template&id=3cc1b710&"
import script from "./poa_programaticas.vue?vue&type=script&lang=ts&"
export * from "./poa_programaticas.vue?vue&type=script&lang=ts&"
import style0 from "./poa_programaticas.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports